import api from "../Api";

export const affiliateLoginApi = (data) =>
  api.post("/affiliate/auth/login", data);

export const affiliateProfileApi = () =>
  api.get("/affiliate/profile");

export const getAffiliateDashboardCardsApi = () => {
  return api.get("/affiliate-service/overview");
};

export const getReferralslist = (status = '', earning_type = '', start_date = '', end_date = '', type = 'sum') => {
  let s = status, e = earning_type, sd = start_date, ed = end_date, t = type;
  if (typeof status === 'object' && status !== null) {
    s = status.status || '';
    e = status.earning_type || '';
    sd = status.start_date || '';
    ed = status.end_date || '';
    t = status.type !== undefined ? status.type : 'sum';
  }
  const query = new URLSearchParams();
  if (s) query.append('status', s);
  if (e) query.append('earning_type', e);
  if (sd) query.append('start_date', sd);
  if (ed) query.append('end_date', ed);
  if (t) query.append('type', t);
  return api.get(`/affiliate-service/referrals/list?${query.toString()}`);
};

export const getanalyticstrends = () => {
  return api.get("/affiliate-service/analytics/trends");
};

export const getanalyticsCards = () => {
  return api.get("/affiliate-service/analytics/card");
};

export const getAffiliateBadges = () => {
  return api.get("/affiliate-service/users/badges");
};

export const getAnalyticsGraph = (filter) => {
  return api.get(`/affiliate-service/analytics/graph?period=${filter}`);
};

export const getAnalyticsperformance = () => {
  return api.get(`/affiliate-service/analytics/performance`);
};

export const getProfile = () => {
  return api.get(`/affiliate-service/analytics/profile`);
};

export const getRequestLink = () => {
  return api.put(`/affiliate-service/request-affiliate`);
};

export const getUserupdated = (payload) => {
  return api.put(`/user-service/profile`, payload);
};

export const getwithdrawRequest = (payload) => {
  return api.put(`/affiliate-service/withdraw-request/list`, payload);
};

// /affiliate-service/withdraw-request/list
// /user-service/profile

// /affiliate-service/request-affiliate

// /affiliate-service/analytics/profile


// Chat Messages

// /chat-service/conversations/1
export const getChatMessages = (conversationId) => {
  return api.get(`/chat-service/conversations/${conversationId}/messages?page=1&page_size=200`);
};
// /chat-service/messages
export const sendChatMessage = (formData) => {
  return api.post(`/chat-service/messages`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// /chat-service/conversations
export const createConversationApi = () => {
  return api.post(`/chat-service/conversations`);
};

// /user-service/wallet/transaction-history
export const getUserWalletTransactionHistory = () => {
  return api.get(`/user-service/wallet/transaction-history`);
};

export const getAffiliateEstimateList = (search = '', fromDate = '', toDate = '', page = 1, limit = 10) => {
  const q = encodeURIComponent(search ?? '');
  return api.get(
    `/affiliate-service/affiliate/estimates/list?page=${page}&limit=${limit}&search=${q}&from_date=${fromDate}&to_date=${toDate}`
  );
};

export const createAffiliateEstimate = (data) => {
  return api.post('/affiliate-service/affiliate/estimate', data);
};

export const getAffiliateMeetingListApi = (page = 1, pageSize = 20, search = '', status = 'All', dateFilter = 'All Time') => {
  const query = new URLSearchParams({
    page,
    page_size: pageSize,
    sort_by: 'scheduled_at',
    sort_order: 'desc'
  });
  if (search) query.append('search', search);
  if (status && status !== 'All') query.append('status', status);
  
  return api.get(`/meet-service/api/v1/meetings?${query.toString()}`);
};